module.exports = ".daterangepickerwidth {\r\n    width: 100%;\r\n}\r\n\r\n#rm-deligate {\r\n    min-height: 85vh;\r\n}\r\n\r\n.open_icon {\r\n    -webkit-transform: rotate(90deg);\r\n    transform: rotate(90deg);\r\n    cursor: pointer;\r\n}\r\n\r\n.btn:hover {\r\n    color: #fff;\r\n}\r\n\r\n@media (max-width:500px) {\r\n    .mobile-style {\r\n        text-align: center;\r\n    }\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/rm/deligate/add-deligate/add-deligate.component.css
// module id = ./src/app/rm/deligate/add-deligate/add-deligate.component.css
// module chunks = main